import { useCallback } from 'react';
import { type ValidationErrors } from 'final-form';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as helpers from '../helpers';
import * as Types from '../types';

export const useValidate = (documentGroup: Types.IDocumentGroupConfig) => {
    const translate = useComponentTranslations();
    const { documentType, documentExpDate } = documentGroup;

    return useCallback((values: Types.IDocumentGroupFormValues): ValidationErrors => {
        const errors: ValidationErrors = {};

        if (documentType && !values.documentType) {
            errors.documentType = translate('playtech.mobile.system.tooltip.required');
        }

        if (values.documentNumber && (values.documentNumber.length < 2 || values.documentNumber.length > 100)) {
            errors.documentNumber = translate('validation.documentNumber.length');
        }

        if (documentExpDate && !values.noExpDate && !helpers.checkRequiredDate(values.documentExpDate)) {
            errors.documentExpDate = translate('playtech.mobile.system.tooltip.required');
        }

        return errors;
    }, [documentType, documentExpDate, translate]);
};
